import { Container, Row } from "reactstrap";
import { ChartTitle, CryptoAnnotationsTitle, CryptocurrencyPricesTitle, FinanceTitle, LiveProductsTitle, MonthlyHistoryTitle, MonthlySalesTitle, OrderStatusTitle, ProjectCreatedTitle, SalesOverviewTitle, StockMarketTitle, TurnOverTitle, UsersTitle, WidgetTitle } from "../../../../constants";
import CommonChart from "./CommonChart";
import TotalSale from "./TotalSale";
import { CryptoAnnotationsChart, CryptocurrencyPricesChart, FinanceChart, LiveProductsChart, MonthlyHistoryChart, MonthlySalesChart, OrderStatusChart, RevenueGrowth, SalesOverviewChart, StockMarketChart, TurnOverChart, UsesChart } from "../../../../data/general/widgets/Chart";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

const ChartContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ChartTitle} parent={WidgetTitle} />
      <Container fluid>
        <Row>
          <TotalSale />
        </Row>
        <Row>
          <CommonChart title={ProjectCreatedTitle} options={RevenueGrowth} series={RevenueGrowth.series ?? []} colClass="col-xl-6 col-lg-12 box-col-6 xl-50" chartHeight={335}/>
          <CommonChart title={SalesOverviewTitle} options={SalesOverviewChart} series={SalesOverviewChart.series ?? []} colClass="col-xl-6 col-lg-12 box-col-6 xl-50" chartHeight={335}/>
          <CommonChart title={MonthlyHistoryTitle} options={MonthlyHistoryChart} series={MonthlyHistoryChart.series ?? []} colClass="col-md-12 box-col-12" chartHeight={380}/>
        </Row>
        <Row>
          <CommonChart title={LiveProductsTitle} options={LiveProductsChart} series={LiveProductsChart.series ?? []} colClass="xl-50 col-xl-7 col-lg-12" chartHeight={320}/>
          <CommonChart title={TurnOverTitle} options={TurnOverChart} series={TurnOverChart.series ?? []} colClass="xl-50 col-xl-5 col-lg-12" chartHeight={300}/>
          <CommonChart title={CryptocurrencyPricesTitle} options={CryptocurrencyPricesChart} series={CryptocurrencyPricesChart.series ?? []} colClass="xl-50 col-xl-6 col-lg-12" chartHeight={400}/>
          <CommonChart title={CryptoAnnotationsTitle} options={CryptoAnnotationsChart} series={CryptoAnnotationsChart.series ?? []} colClass="xl-50 col-xl-6 col-lg-12" chartHeight={400}/>
        </Row>
        <Row>
          <CommonChart title={StockMarketTitle} options={StockMarketChart} series={StockMarketChart.series ?? []} colClass="col-sm-12 box-col-12" chartHeight={450}/>
          <CommonChart title={FinanceTitle} options={FinanceChart} series={FinanceChart.series ?? []} colClass="col-xl-5 col-lg-12 box-col-5" chartHeight={350}/>
          <CommonChart title={OrderStatusTitle} options={OrderStatusChart} series={OrderStatusChart.series ?? []} colClass="col-xl-7 col-lg-12 box-col-7" chartHeight={350}/>
          <CommonChart title={MonthlySalesTitle} options={MonthlySalesChart} series={MonthlySalesChart.series ?? []} colClass="xl-50 col-xl-5 col-lg-12 box-col-5" chartHeight={300}/>
          <CommonChart title={UsersTitle} options={UsesChart} series={UsesChart.series ?? []} colClass="xl-50 col-xl-7 col-lg-12 box-col-7" chartHeight={300}/>
        </Row>
      </Container>
    </>
  );
};

export default ChartContainer;
